'use es6';

import { TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME } from 'tinymce-themes/constants/toolbar';
import { HR_SETTINGS, hshrConfig } from '../constants/hshr';
import { getPluginSetting } from '../utils';
import { getParentCallout } from '../utils/callout';
function getHRPluginSetting(editor, setting) {
  const hrPluginSettings = getPluginSetting(editor, HR_SETTINGS);
  if (hrPluginSettings) {
    return hrPluginSettings[setting];
  }
  return null;
}
function insideElementType(editor, selectedNode, nodeName) {
  return !!editor.dom.getParent(selectedNode, node => node.nodeName === nodeName, editor.getBody());
}
export function addHandlers(editor) {
  const disableInsertion = getHRPluginSetting(editor, hshrConfig.DISABLE_INSERTION);
  if (disableInsertion) {
    const onNodeChange = () => {
      const selectedNode = editor.selection.getNode();
      const insideCallout = !!getParentCallout(editor, selectedNode);
      const insideCobeblock = insideElementType(editor, selectedNode, 'PRE');
      const insideBlockquote = insideElementType(editor, selectedNode, 'BLOCKQUOTE');
      editor.fire(TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME, {
        name: 'hshr',
        disabled: insideCallout || insideCobeblock || insideBlockquote
      });
    };
    editor.on('NodeChange', onNodeChange);
  }
}